import { combineReducers, Reducer } from 'redux';

import { WaveEvent } from '@anm/api/modules/waveEvents';

import {
  GET_CURRENT_WAVE_EVENT_ERROR,
  GET_CURRENT_WAVE_EVENT_REQUEST,
  GET_CURRENT_WAVE_EVENT_SUCCESS,
  UPDATE_CURRENT_WEEK,
  WaveEventsActions,
  WAVE_EVENT_LIST_ERROR,
  WAVE_EVENT_LIST_REQUEST,
  WAVE_EVENT_LIST_SUCCESS
} from './actions';
import { CurrentWaveEventState, WaveEventListState } from './types';

const initialWaveEventListState: WaveEventListState = {
  isError: false,
  isPending: false,
  dateEvents: {},
  startWeekDate: '',
  endWeekDate: ''
};

const waveEventListReducer: Reducer<WaveEventListState, WaveEventsActions> = (
  state = initialWaveEventListState,
  action
) => {
  switch (action.type) {
    case UPDATE_CURRENT_WEEK: {
      const { startWeekDate, endWeekDate } = action.payload;

      return {
        ...state,
        startWeekDate,
        endWeekDate
      };
    }
    case WAVE_EVENT_LIST_REQUEST: {
      return {
        ...state,
        isError: false,
        isPending: true
      };
    }
    case WAVE_EVENT_LIST_SUCCESS: {
      const { dateEvents, startWeekDate } = state;
      const { list: newEvents } = action.payload;
      dateEvents[startWeekDate] = newEvents;

      return {
        ...state,
        dateEvents,
        isPending: false
      };
    }
    case WAVE_EVENT_LIST_ERROR: {
      const { payload: newError } = action;
      return {
        ...state,
        error: newError,
        isError: true,
        isPending: false
      };
    }
    default:
      return state;
  }
};

const initialCurrentWaveEventState: CurrentWaveEventState = {
  data: {} as WaveEvent,
  isError: false,
  isPending: false
};

const currentWaveEventReducer: Reducer<
  CurrentWaveEventState,
  WaveEventsActions
> = (state = initialCurrentWaveEventState, action) => {
  switch (action.type) {
    case GET_CURRENT_WAVE_EVENT_REQUEST: {
      return {
        ...state,
        isError: false,
        isPending: true
      };
    }
    case GET_CURRENT_WAVE_EVENT_SUCCESS: {
      const { payload: newWaveEvent } = action;
      return {
        ...state,
        data: newWaveEvent,
        isPending: false
      };
    }
    case GET_CURRENT_WAVE_EVENT_ERROR: {
      const { payload: newError } = action;
      return {
        ...state,
        error: newError,
        isError: true,
        isPending: false
      };
    }
    default:
      return state;
  }
};

const waveEventReducer = combineReducers({
  waveEventItems: waveEventListReducer,
  currentWaveEvent: currentWaveEventReducer
});

export default waveEventReducer;
